import pkg from "../package.json";

export const APP_VERSION = pkg.version;
export const APP_AUTHOR = pkg.name;
